// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectList_wrapper_DUmxt","container":"ProjectList_container_JXl3p","card":"ProjectList_card_LoW2a","projectName":"ProjectList_projectName_ctd6o"};